import {
    AppData,
    Colors,
    Img,
    Lightning,
    Router,
    Log,
    Registry,
} from "@lightningjs/sdk";
import { AppSetup } from "../lib/app-setup";
import GridViewModel, {
    FocusInfo,
} from "../lib/components/grid/grid-view-model";
import { ItemNode } from "../lib/components/grid/ItemNode";
import MultiRowGrid from "../lib/components/grid/multirow-grid";
import { Logger } from "../lib/logger";
import { GRIDTYPE } from "../lib/enum";
import { AppApiConfig } from "../lib/app-api-config";
import { Helper } from "../lib/helper";

export interface VideoPlaylistUITemplateSpec
    extends Lightning.Component.TemplateSpec {
    Background: object;
    Label: object;
    RowListWrapper: object;
    MultiRowGrid: object;
}

export default class VideoPlaylistUI
    extends Lightning.Component<VideoPlaylistUITemplateSpec>
    implements Lightning.Component<VideoPlaylistUITemplateSpec>
{
    Background = this.getByRef("Background")!;
    Label = this.getByRef("Label")!;
    RowListWrapper = this.getByRef("RowListWrapper")!;
    MultiRowGrid = this.getByRef("MultiRowGrid")!;
    _item: any;
    gridViewModel!: GridViewModel;
    playingVideoInfo!: FocusInfo;
    private _focusAnimation: Lightning.types.Animation | undefined = undefined;

    autoHidePlaylistIntv: any;
    autoHidePlaylistTime = 6;
    autoHidePlaylistCnt = 0;
    playlistOn = true;
    isFocusedOnce = false;
    previousRowTitle = ''

    static override _template(): Lightning.Component.Template<VideoPlaylistUITemplateSpec> {
        return {
            color: 0x88000000,
            rect: true,
            w: (w: any) => w,
            h: (h: any) => VIDEO_PLAYLIST_HEIGHT,
            y: (h: any) => h, //-VIDEO_PLAYLIST_HEIGHT,
            RowListWrapper: {
                x: 40,
                y: 10,
                w: 1920,
                h: 380,
                clipping: true,
                MultiRowGrid: undefined,
            },
            ItemTitle: { x: 80, y: 380, text: { text: '', fontSize: 30, fontFace: Helper.getFontFamily('Regular') } },
            // fontFace: 'Fresca',
        };
    }

    override _init() {
        //let w=1920;
        let h = 1080;
        //let w = (w: any) => w;
        //let h = (h: any) => h;
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.gridViewModel = app?.loadVideoPlaylist();
        this.playingVideoInfo = {
            focusRow: this.gridViewModel.getFocusInfo().focusRow,
            foucsItem: this.gridViewModel.getFocusInfo().foucsItem,
        };
        this.gridViewModel.on("loaded", this._gridLoadedHandler, this);
        this.gridViewModel.on("focused", this._gridFocusedHandler, this);
        this.gridViewModel.on("selected", this._gridSelectedHandler, this);

        this.gridViewModel._init();

        this._focusAnimation = this.animation({
            duration: 0.5,
            actions: [{ p: "y", v: { 0: h, 1: h - VIDEO_PLAYLIST_HEIGHT } }],
        });
    }

    override _firstActive() { }

    override _focus() {
        Logger.processUserAction('playlistLaunch');
        // const { platform } = AppData as AppSetup;
        // const vodItem = this.gridViewModel.getFocusedItem()
        // platform?.textToSpeach(vodItem.title)
        // this.isFocusedOnce = true;
        this._focusAnimation?.start();
        this.startAutoHidePlaylistTimer();
        this.gridViewModel.changeFocus(this.playingVideoInfo);
        this.tag("MultiRowGrid").resetFocus(this.playingVideoInfo, this.playingVideoInfo.foucsItem)
    }

    override _unfocus() {
        //Logger.processUserAction('playlistClosed');
        this.stopAutoHidePlaylistTimer();
        this._focusAnimation?.stop();        
    }

    override _getFocused() {
        return this.tag("MultiRowGrid");
    }

    override _detach() {
        this.gridViewModel.off("loaded", this._gridLoadedHandler, this);
        this.gridViewModel.off("focused", this._gridFocusedHandler, this);
        this.gridViewModel.off("selected", this._gridSelectedHandler, this);
        this.isFocusedOnce = false;
        this.stopAutoHidePlaylistTimer();
    }

    $handleUp(): boolean | void {
        this.hidePlaylist();
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.hidePlaylist();
    }

    _gridLoadedHandler(event: any) {
        const style = Helper.getRowStyle(this.gridViewModel.getRowAt(0))
        this.patch({
            RowListWrapper: {
                h: style.row_height + 24,
                MultiRowGrid: {
                    x: 40,
                    y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    grid: this.gridViewModel,
                    type: MultiRowGrid,
                    parentType: "playlist"
                },
            },
        });
        this.gridViewModel.changeFocus(this.playingVideoInfo);
    }

    _gridFocusedHandler(event: any) {
        const { appState, platform } = AppData as AppSetup;
        const app = appState?.getApp();
        const appApiConfig:AppApiConfig = appState?.getAppApiConfig();
        // let parentGrid = app?.navigation.getCurrentGrid();
        // const focusInfo: FocusInfo = parentGrid?.getFocusInfo()!
        // focusInfo.foucsItem = this.gridViewModel.getFocusInfo().foucsItem
        // const focusRow = this.gridViewModel.getRowAt(focusInfo.focusRow)
        // if (focusRow?.description == 'dynid') {
        //     parentGrid = app?.dynidGrid.changeFocus({ focusRow: focusInfo.focusRow, foucsItem: focusInfo.foucsItem })
        // }
        // parentGrid?.changeFocus(focusInfo);
        const vodItem = this.gridViewModel.getFocusedItem()
        if(vodItem && vodItem.title){
            this.tag('ItemTitle')?.patch({
                text: { text: vodItem.title }
            })
        }
        const focusRow = this.gridViewModel.getRowAt(this.gridViewModel.getFocusInfo().focusRow)
        let tts = ''
        if(this.previousRowTitle !== focusRow?.name){
            tts += focusRow?.name
            this.previousRowTitle = focusRow?.name
        }
        tts += vodItem.title
        platform?.textToSpeach(tts)
        this.autoHidePlaylistCnt = 0
    }

    _gridSelectedHandler(event: any) {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let parentGrid = app?.navigation.getCurrentGrid();
        const currInfo = this.gridViewModel.getFocusedItem();
        if(app?.blockingManager.isItemBlocked(currInfo)){
            const page = Router.getActivePage()
            page.widgets.notification.showMessage('')
            return;
        }
        const focusRow = this.gridViewModel.getRowAt(this.gridViewModel.getFocusInfo().focusRow)
        const playingRow = this.gridViewModel.getRowAt(this.playingVideoInfo.focusRow)
        let isDynidSelected = false
        if (parentGrid?.type !== GRIDTYPE.DYNID && focusRow?.description == 'dynid') {
            //app?.dynidGrid.changeFocus({ focusRow: 0, foucsItem: focusInfo.foucsItem })
            app?.navigation.push(app.dynidGrid)
            parentGrid = app?.navigation.getCurrentGrid();
        } else {
            if(playingRow?.description == 'dynid' && focusRow?.description !== 'dynid') {
                app?.navigation.pop();
            }
            parentGrid = app?.navigation.getCurrentGrid();
        }
        let focusInfo: FocusInfo = parentGrid?.getFocusInfo()!
        focusInfo.foucsItem = this.gridViewModel.getFocusInfo().foucsItem
        parentGrid?.changeFocus(focusInfo);
        const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();

        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;
        Log.info(
            "MainGridTemplateSpec:_gridSelectedHandler: ",
            this.gridViewModel.getFocusInfo(),
            vodInfo
        );

        if (
            vodInfo.type == "listoflist" ||
            vodInfo.type == "new-qid" ||
            vodInfo.feed_type == "banner"
        ) {
            this.fireAncestors("$reset");

            Router.navigate(`mlp-grid-screen/${vodInfo.id}`, false);
        } else if (vodInfo.feed_type == "video") {
            this.fireAncestors("$reset");
            setTimeout(() => {
                Router.navigate("video-screen/" + vodInfo.node_id + '_playlist_r_' + new Date().getTime(), false);
            }, 200);
        }
    }

    startAutoHidePlaylistTimer = () => {
        this.stopAutoHidePlaylistTimer();
        this.autoHidePlaylistIntv = Registry.setInterval(() => {
            this.autoHidePlaylistCnt++
            if(this.autoHidePlaylistCnt >= this.autoHidePlaylistTime) {
                this.hidePlaylist();
            }
        }, 1000);
    };

    stopAutoHidePlaylistTimer = () => {
        this.autoHidePlaylistCnt = 0
        Registry.clearInterval(this.autoHidePlaylistIntv);
    };

    hidePlaylist = () => {
        this.playlistOn = false;
        this.stopAutoHidePlaylistTimer()
        this.fireAncestors("$hide");
    };
}
const VIDEO_PLAYLIST_HEIGHT = 610;
const controlsBGColorFocus = 0x88ff0000;
const controlsBGColorUnFocus = 0x8800ff00;
